import { render, staticRenderFns } from "./ReadComic.vue?vue&type=template&id=83bbd058&"
import script from "./ReadComic.vue?vue&type=script&lang=ts&"
export * from "./ReadComic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports